import { PropType, ExtractPropTypes } from 'vue'
import type { CascaderProps as AntCascaderProps } from 'ant-design-vue'
import type { ShowSearchType } from 'ant-design-vue/es/cascader'

export interface Option {
  [name: string]: any
  isLeaf?: boolean
  loading?: boolean
  className?: string
}

export interface FieldNames {
  label?: string
  value?: string
  children?: string
}

export type LoadDataFn = (selectedOptions: Option[], resolve: (options: Option[]) => void) => void
export type RemoteSearchFn = (key: string, resolve: () => void) => void

export const cascaderProps = {
  value: {
    type: Array as PropType<Array<string | number>>,
    default: () => []
  },
  options: {
    type: Array as PropType<Option[]>,
    default: () => [],
    require: true
  },
  loadData: {
    type: Function as PropType<LoadDataFn>
  },
  allowClear: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  searchPlaceholder: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  activeColor: {
    type: String,
    default: '#1890FF'
  },
  changeOnSelect: {
    type: Boolean,
    default: false
  },
  remoteSearch: {
    type: Function as PropType<RemoteSearchFn>
  },
  displayRender: {
    type: Function as PropType<AntCascaderProps['displayRender']>
  },
  filter: {
    type: [Function, Boolean] as PropType<ShowSearchType['filter'] | boolean>
  },
  fieldNames: {
    type: Object as PropType<FieldNames>,
    default: {
      value: 'value',
      label: 'label',
      children: 'children'
    }
  },
  expandTrigger: {
    type: String as PropType<'hover' | 'click'>,
    default: 'click'
  }
}

export type CascaderProps = ExtractPropTypes<typeof cascaderProps>
